<button class="btn btn-default" type="button" (click)="copy()">
  <img src="assets/images/icons/copy.png"/>
</button>
